const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/login/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
const searchSchema = z.object({
  mode: z.enum(['standard', 'org-prompt']).optional(),
  token: z.string().optional(),
  error: z.string().optional(),
  email: z.string().optional(),
  returnTo: z.string().optional(),
  org: z.string().optional()
});
export const Route = createFileRoute('/(unauthenticated)/login/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(searchSchema),
  beforeLoad: () => ensureNamespaceLoaded('login')
});